import { render, staticRenderFns } from "./HouseCrossSection.vue?vue&type=template&id=609a2324&scoped=true"
import script from "./HouseCrossSection.vue?vue&type=script&lang=ts"
export * from "./HouseCrossSection.vue?vue&type=script&lang=ts"
import style0 from "./HouseCrossSection.vue?vue&type=style&index=0&id=609a2324&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a2324",
  null
  
)

export default component.exports